// app/javascript/offcanvas_forms.js
import * as bootstrap from "bootstrap";

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta && meta.content;
}

function openOffcanvasWith(url, title = "") {
  const body = document.getElementById("drawer-body");
  const label = document.getElementById("drawerLabel");
  label.textContent = title || "";
  body.innerHTML = '<div class="text-muted text-center py-5">Carregando…</div>';

  fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
    .then(r => r.text())
    .then(html => {
      body.innerHTML = html;
    })
    .catch(() => {
      body.innerHTML = '<div class="text-danger">Falha ao carregar.</div>';
    });

  const el = document.getElementById("drawer-offcanvas");
  const off = bootstrap.Offcanvas.getOrCreateInstance(el);
  off.show();
}

function handleDelegatedClicks(e) {
  const a = e.target.closest("a.js-offcanvas-link");
  if (!a) return;
  e.preventDefault();
  openOffcanvasWith(a.href, a.dataset.title);
}

function handleDelegatedSubmits(e) {
  const form = e.target.closest("form.js-offcanvas-form");
  if (!form) return;
  e.preventDefault();

  const formData = new FormData(form);
  const method = (form.querySelector('input[name="_method"]')?.value || form.method || "post").toUpperCase();

  fetch(form.action, {
    method: method === "GET" ? "POST" : method, // PATCH/POST
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-Token": csrfToken()
    },
    body: formData
  })
    .then(async (r) => {
      if (r.ok && r.headers.get("content-type")?.includes("application/json")) {
        const json = await r.json();
        if (json.ok) {
          // atualiza/insere a linha
          const tbody = document.getElementById("event-types-tbody");
          const temp = document.createElement("tbody");
          temp.innerHTML = json.row_html.trim();
          const row = temp.querySelector("tr");
          if (row) {
            const existing = document.getElementById(row.id);
            if (existing) {
              existing.replaceWith(row);
            } else {
              tbody.prepend(row);
            }
          }
          // fechar offcanvas
          const el = document.getElementById("drawer-offcanvas");
          const off = bootstrap.Offcanvas.getInstance(el);
          off && off.hide();
        } else {
          // fallback: reload
          window.location.reload();
        }
      } else if (r.status === 422) {
        // voltou o form com erros (HTML)
        const html = await r.text();
        document.getElementById("drawer-body").innerHTML = html;
      } else {
        // algo inesperado
        window.location.reload();
      }
    })
    .catch(() => window.location.reload());
}

document.addEventListener("click", handleDelegatedClicks);
document.addEventListener("submit", handleDelegatedSubmits);
